import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@personal-area/common';
import { DEVICE_DETECTOR, DeviceDetector } from '../models/token';

@Injectable({
  providedIn: 'root'
})
export class PwaDetectorService {
  private readonly _isStandalone: boolean = false;

  constructor(
    @Inject(DEVICE_DETECTOR) private _deviceDetector: DeviceDetector,
    @Inject(WINDOW) _window: Window,
    ) {
    if (_window && _window.matchMedia) {
      this._isStandalone = _window.matchMedia('(display-mode: standalone)').matches;
    }
  }

  public isInPwaMode(): boolean {
    return this._isStandalone;
  }

  public isInPartnerPwaMode(): boolean {
    return this._isStandalone && this._deviceDetector.isAndroid;
  }
}
